export const RETURN_TO_LATEST_THRESHOLD = 120;

/** In an inverted list, offset zero is the newest message. */
export function isNearLatest(offset: number) {
  return offset < RETURN_TO_LATEST_THRESHOLD;
}

export function shouldFollowLatest(nearLatest: boolean, sentByCurrentIdentity: boolean) {
  return nearLatest || sentByCurrentIdentity;
}
